"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.METHOD_POST = exports.CONTENT_TYPE_VALUE_JSON = exports.CONTENT_TYPE_VALUE_PROTOBUF = exports.CONTENT_TYPE_HEADER = exports.FIPS_IGNORE_ERROR_ENV_VAR = exports.FIPS_ENV_VAR = exports.DATADOG_SITES = exports.DATADOG_SITE_US2_GOV = exports.DATADOG_SITE_GOV = exports.DATADOG_SITE_AP2 = exports.DATADOG_SITE_AP1 = exports.DATADOG_SITE_US5 = exports.DATADOG_SITE_US3 = exports.DATADOG_SITE_EU1 = exports.DATADOG_SITE_US1 = void 0;
exports.DATADOG_SITE_US1 = 'datadoghq.com';
exports.DATADOG_SITE_EU1 = 'datadoghq.eu';
exports.DATADOG_SITE_US3 = 'us3.datadoghq.com';
exports.DATADOG_SITE_US5 = 'us5.datadoghq.com';
exports.DATADOG_SITE_AP1 = 'ap1.datadoghq.com';
exports.DATADOG_SITE_AP2 = 'ap2.datadoghq.com';
exports.DATADOG_SITE_GOV = 'ddog-gov.com';
exports.DATADOG_SITE_US2_GOV = 'us2.ddog-gov.com';
exports.DATADOG_SITES = [
    exports.DATADOG_SITE_US1,
    exports.DATADOG_SITE_EU1,
    exports.DATADOG_SITE_US3,
    exports.DATADOG_SITE_US5,
    exports.DATADOG_SITE_AP1,
    exports.DATADOG_SITE_AP2,
    exports.DATADOG_SITE_GOV,
    exports.DATADOG_SITE_US2_GOV,
];
// Common env vars
exports.FIPS_ENV_VAR = 'DATADOG_FIPS';
exports.FIPS_IGNORE_ERROR_ENV_VAR = 'DATADOG_FIPS_IGNORE_ERROR';
exports.CONTENT_TYPE_HEADER = 'Content-Type';
exports.CONTENT_TYPE_VALUE_PROTOBUF = 'application/x-protobuf';
exports.CONTENT_TYPE_VALUE_JSON = 'application/json';
exports.METHOD_POST = 'post';
//# sourceMappingURL=constants.js.map